// extracted by mini-css-extract-plugin
module.exports = {"container":"newsFeed-module__container___w2zhz","newsItems":"newsFeed-module__newsItems___2GL0y","readMore":"newsFeed-module__readMore___1ZJ8J"};